import Hub from '../hub.js';

class ProductViewsTracker {
    constructor() {
        this.products = [];
        this.observer = this.createObserver();
    }

    unregisterElement(element) {
        this.observer.unobserve(element);
    }

    registerElement(element) {
        if (!this.products.find(i => i === element)) {
            this.observer.observe(element);
            this.products.push(element);
        }
    }

    registerElements(elements) {
        [].forEach.call(elements, this.registerElement.bind(this));
    }

    onIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);

                Hub.publish(Hub.PRODUCT_VIEW, {
                    target: entry.target
                });
            }
        });
    }

    createObserver() {
        const options = {
            rootMargin: '0px',
            threshold: 0.5
        };

        return new IntersectionObserver(this.onIntersection.bind(this), options);
    }
}

const productViewsTracker = new ProductViewsTracker();

export default productViewsTracker;
